module.exports = __webpack_public_path__ + "img/RCV_1280x1010.3d624fc9.jpg";